/**
 * Berechnet die Anzahl der Jahre Berufserfahrung seit September 2006
 * @returns {number} Anzahl der Jahre Berufserfahrung (gerundet)
 */
export function getYearsOfExperience(): number {
  const careerStartDate = new Date(2006, 8, 1); // September 2006 (Monate in JS sind 0-basiert, daher 8 für September)
  const currentDate = new Date();

  const yearsDiff = currentDate.getFullYear() - careerStartDate.getFullYear();

  // Berücksichtige den Monat, um keine Jahre "aufzurunden", die noch nicht erreicht sind
  if (
    currentDate.getMonth() < careerStartDate.getMonth() ||
    (currentDate.getMonth() === careerStartDate.getMonth() &&
      currentDate.getDate() < careerStartDate.getDate())
  ) {
    return yearsDiff - 1;
  }

  return yearsDiff;
}

/**
 * Gibt die Anzahl der Jahre Berufserfahrung mit "+" zurück
 * @returns {string} z.B. "17+"
 */
export function getFormattedYearsOfExperience(): string {
  return `${getYearsOfExperience()}+`;
}

const GERMAN_MONTHS = [
  'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
  'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
] as const;

/**
 * Wandelt "YYYY-MM" in "Monat YYYY" um (z.B. "2025-03" → "März 2025").
 * Gibt bei ungültigem Input den Originalwert zurück.
 */
export function formatMonthYear(isoMonth: string): string {
  const match = /^(\d{4})-(\d{2})$/.exec(isoMonth);
  if (!match) return isoMonth;
  const [, year, monthStr] = match;
  const monthIndex = Number(monthStr) - 1;
  if (monthIndex < 0 || monthIndex > 11) return isoMonth;
  return `${GERMAN_MONTHS[monthIndex]} ${year}`;
}